import useFetch, { useFetchMute, useFetchMuteParam } from '@hooks/useFetch';

// =================================================================
//                          Code API
// =================================================================
export const code = {
  /**
   * 공통코드 목록 전체 조회
   * @param {*} key
   * @param {*} option
   * @returns
   */
  getComCdList(key, option) {
    return useFetch(key, 'get', '/code', null, { ...option });
  },
  getComCdByParComCd(key, option, params) {
    return useFetch(key, 'get', `/code/${params}`, null, { ...option });
  },
};

// =================================================================
//                          Clause API
// =================================================================
export const clause = {
  /**
   * 약관 목록 조회
   * @param {*} key
   * @param {*} option
   * @returns
   */
  getClauseList(key, option, param) {
    return useFetch(key, 'get', '/clause', param, { ...option });
  },
};

// =================================================================
//                          App API
// =================================================================
export const app = {
  /**
   * 앱 마지막 버전 정보 조회
   */
  getLastAppVersion(key, option, param) {
    return useFetch(key, 'get', '/app/ver/last', param, { ...option });
  },
};

// =================================================================
//                          MdctFeed API
// =================================================================
export const mdctFeed = {
  /**
   * 투약 AI 조언 프롬프트 템플릿 조회
   */
  getMdctFeedPrptTmpt(key, option, param) {
    return useFetch(key, 'get', '/mdct/tmpt', param, option);
  },
  /**
   * 투약피드 수정
   * @param {*} option
   * @returns
   */
  putMdctFeedDtl(option) {
    return useFetchMuteParam('put', '/mdct', option);
  },
};

export const ext = {
  /**
   * 사용자 정보 조회
   */
  getUserInfo(key, option, params) {
    return useFetch(key, 'get', `/ext/user`, params, { ...option });
  },

  /**
   * 사용자 정보 수정
   */
  putUserInfo(option, params) {
    return useFetchMute('put', `/ext/user`, params, { ...option });
  },

  /**
   * 가족 관계 정보 조회
   */
  getFamilyCareRelInfo(key, option, params) {
    return useFetch(key, 'get', `/ext/family-care`, params, { ...option });
  },

  /**
   * 건강보험공단 간편인증
   */
  postAuthgNhis(option, params) {
    return useFetchMute('post', `/scraping/nhis/auth`, params, { ...option });
  },

  /**
   * 건강보험심사평가원 간편인증
   */
  postAuthHira(option, params) {
    return useFetchMute('post', `/scraping/hira/auth`, params, { ...option });
  },

  /**
   * 가족회원 건강검진 스크래핑
   */
  postScrapingNhis(option, params) {
    return useFetchMute('post', `/family-mediexam/auth/confirm`, params, { ...option });
  },

  /**
   * 가족회원 처방전 스크래핑
   */
  postScrapingHira(option, params) {
    return useFetchMute('post', `/family-prscpt/auth/confirm`, params, { ...option });
  },

  /**
   * 가족회원 건강예측 스크래핑
   */
  postScrapingHelt(option, params) {
    return useFetchMute('post', `/family-helt/auth/confirm`, params, { ...option });
  },

  /**
   * 인층 요청 테이블 업데이트
   */
  createExternalAuthInfo(option, params) {
    return useFetchMute('post', `/ext/auth`, params, { ...option });
  },
};

// =================================================================
//                          AiAgent API
// =================================================================
export const aiAgent = {
  /**
   * AI 조언 프롬프트 템플릿 조회
   */
  getAiAgentFeedPrptTmpt(key, option, param) {
    return useFetch(key, 'get', '/ai-feed/tmpt', param, option);
  },
  /**
   * AI 에이전트 피드 수정
   */
  putAiAgentFeed(option) {
    return useFetchMuteParam('put', '/ai-feed', option);
  },
  /**
   * AI 조언 프롬프트 템플릿 조회 for 건강리포트
   */
  getAiAgentFeedPrptTmptForReport(key, option, param) {
    return useFetch(key, 'get', '/ai-feed/report-tmpt', param, option);
  },
  /**
   * AI 에이전트 피드 수정 for 건강리포트
   */
  putAiAgentFeedForReport(option) {
    return useFetchMuteParam('put', '/ai-feed/report', option);
  },
};

// =================================================================
//                          Guide API
// =================================================================
export const guide = {
  /**
   * 가이드 조회
   */
  getSvcChnlGuide(key, option, param) {
    return useFetch(key, 'get', `/guide/${param}`, null, option);
  },
};
